import styled from "styled-components";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { spacing } from "../../../design-system/tokens/spacing";
import { authColors } from "../../../styles/authTokens";
import { authInk, authTypography } from "../../../styles/authBrandTokens";
import type { TextDividerAppearance } from "./TextDivider.types";

type AppearanceProps = { $appearance: TextDividerAppearance };
const isBrand = ({ $appearance }: AppearanceProps) => $appearance === "brand";

export const Wrapper = styled.div<AppearanceProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${(p) => (isBrand(p) ? spacing[3] : p.theme.spacing.base[1])};
  width: 100%;
`;

export const Line = styled.div<AppearanceProps>`
  flex: 1;
  height: 1px;
  background-color: ${(p) => (isBrand(p) ? authInk[200] : authColors.inputBorder)};
`;

export const Label = styled.span<AppearanceProps>`
  ${(p) => (isBrand(p) ? authTypography("divider") : typographyMixin("caption", 4))}
  color: ${(p) => (isBrand(p) ? authInk[500] : authColors.textMedEmphasis)};
  text-align: center;
`;
